export default class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // bindings
    this.onKeyup = this.onKeyup.bind(this);
    this.onClickCartBtn = this.onClickCartBtn.bind(this);
    this.onClickDrawer = this.onClickDrawer.bind(this);
    this.onClickQtyDecrease = this.onClickQtyDecrease.bind(this);
    this.onClickQtyIncrease = this.onClickQtyIncrease.bind(this);
    this.onClickRemoveBtn = this.onClickRemoveBtn.bind(this);
  }

  connectedCallback() {
    // privates
    this._node = this;
    this._cart_btn = document.getElementById('cart-btn');
    this._drawer_scroll = this._node.querySelector('.cart-drawer-scroll');

    this._qty_minus = this._node.querySelectorAll(".qty-minus");
    this._qty_plus = this._node.querySelectorAll(".qty-plus");
    this._remove_btn = this._node.querySelectorAll(".remove-btn");

    this._cart_btn = document.getElementById("cart-btn");
    this._checkout_btn = this._node.querySelector('.checkout-btn');

    // events
    document.addEventListener('keyup', this.onKeyup);
    this._cart_btn.addEventListener('click', this.onClickCartBtn);
    this._node.addEventListener('click', this.onClickDrawer);

    // Check if coming from /cart and auto-open drawer...
    if (window.location.pathname === '/') {
      let cart = document.location.search ? document.location.search === '?cart' : false;

      if (cart && this._cart_btn) {
        this._cart_btn.click();

        if (history.replaceState) {
          let new_url = window.location.origin;
          window.history.replaceState(null, '', new_url);
        }
      }
    }

    // Clear cart if ROD exists... (crazy edge-case)
    this.checkForceEmpty();
  }

  async checkForceEmpty() {
    const cart_res = await fetch("/cart.js");
    const cart_json = await cart_res.json();
    const cart_items = cart_json.items;

    if (cart_items.length > 0) {
      let cef = false;
      cart_items.forEach((item) => {
        if (item.properties && item.properties['Refill Code']) {
          cef = true;
        }
      });

      if (cef) {
        this._checkout_btn.classList.add('--disabled');
        this.emptyCart();
      }
    }
  }

  emptyCart() {
    fetch("/cart/clear.js", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then((response) => {
      if (!response.ok) {
        console.log(response);
        this._checkout_btn.classList.remove('--disabled');
      } else {
        return response.json();
      }
    })
    .then((response) => {
      if (response) {
        this._checkout_btn.classList.remove('--disabled');
        window.location.reload();
      }
    })
  }

  onKeyup(e) {
    let key = e.key;

    if (key === 'Escape' && this._node.classList.contains('--open-drawer')) {
      this.closeDrawer();
    }
  }

  onClickCartBtn() {
    this.openDrawer();
  }

  onClickDrawer(e) {
    let target = e.target,
        id = target.getAttribute('id');

    if (id && id === 'cart-drawer' || target.classList.contains('close-drawer-btn')) {
      this.closeDrawer();
    }

    if (target.classList.contains('qty-minus')) {
      this.onClickQtyDecrease(target);
    }

    if (target.classList.contains('qty-plus')) {
      this.onClickQtyIncrease(target);
    }

    if (target.classList.contains('remove-btn')) {
      this.onClickRemoveBtn(target);
    }
  }

  openDrawer() {
    this._node.classList.add('--open-drawer');

    if (this._drawer_scroll) {
      this._drawer_scroll.scrollTop = 0;
      document.body.style.overflow = 'hidden';
    }

    setTimeout(() => {
      let cart_title = document.getElementById('cart-title');
      if (cart_title && this._node.classList.contains('--open-drawer')) {
        cart_title.setAttribute('tabindex', '-1');
        setTimeout(() => {
          cart_title.focus();
        }, 0);
      }
    }, 666);
  }

  closeDrawer() {
    this._node.classList.remove('--open-drawer');
    document.body.style.overflow = '';

    let cart_title = document.getElementById('cart-title');
    if (cart_title) {
      cart_title.removeAttribute('tabindex');
    }
    setTimeout(() => {
      this._cart_btn.focus();
    }, 0);
  }

  onClickQtyDecrease(el) {
    let cart_item = el.closest(".cart-item"),
        qty_btn = cart_item.querySelector('.quantity-btn'),
        key = cart_item.getAttribute("data-key"),
        new_qty = Math.max((parseInt(cart_item.getAttribute("data-qty"), 10) - 1), 0),
        available_qty = qty_btn.getAttribute('data-available') ? parseInt(qty_btn.getAttribute('data-available'), 10) : false;

    if (available_qty && new_qty >= 0) {
      cart_item.setAttribute("data-qty", new_qty);

      let key_values = { [key]: new_qty }
      this.updateCart(key_values);
      qty_btn.classList.add('--loading');
    }
  }

  onClickQtyIncrease(el) {
    let cart_item = el.closest(".cart-item"),
        qty_btn = cart_item.querySelector('.quantity-btn'),
        key = cart_item.getAttribute("data-key"),
        new_qty = Math.min((parseInt(cart_item.getAttribute("data-qty"), 10) + 1), 10),
        available_qty = qty_btn.getAttribute('data-available') ? parseInt(qty_btn.getAttribute('data-available'), 10) : false;

    if (available_qty && new_qty <= available_qty) {
      cart_item.setAttribute("data-qty", new_qty);

      let key_values = { [key]: new_qty }
      this.updateCart(key_values);
      qty_btn.classList.add('--loading');
    }
  }

  onClickRemoveBtn(el) {
    let cart_item = el.closest(".cart-item"),
        key = cart_item.getAttribute("data-key"),
        refill_id = cart_item.getAttribute('data-rid') ? cart_item.getAttribute('data-rid') : false,
        refill_items = this._node.querySelectorAll(`.cart-item[data-rid]`),
        selling_plan_item = this._node.querySelectorAll(`.cart-item[data-vid="${refill_id}"]`),
        addon_refill_id = cart_item.getAttribute('data-add-rid-id') ? cart_item.getAttribute('data-add-rid-id') : false,
        addon_refill_item = this._node.querySelectorAll(`.cart-item[data-add-id="${addon_refill_id}"]`),
        addon_gift_id = cart_item.getAttribute('data-add-gid-id') ? cart_item.getAttribute('data-add-gid-id') : false,
        addon_gift_item = this._node.querySelectorAll(`.cart-item[data-add-id="${addon_gift_id}"]`),
        key_values = { [key]: 0 };

    if (refill_id && selling_plan_item.length > 0) {
      selling_plan_item.forEach((el) => {
        if (el.getAttribute('data-vid') === cart_item.getAttribute('data-rid')) {
          key_values[el.getAttribute("data-key")] = 0;
        }
      })
    }

    if (addon_refill_id && addon_refill_item.length > 0) {
      addon_refill_item.forEach((el) => {
        if (addon_refill_id === el.getAttribute('data-add-id')) {
          key_values[el.getAttribute("data-key")] = 0;
        }
      });
    }

    if (addon_gift_id && addon_gift_item.length > 0) {
      addon_gift_item.forEach((el) => {
        if (addon_gift_id === el.getAttribute('data-add-id')) {
          key_values[el.getAttribute("data-key")] = 0;
        }
      });
    }

    this.updateCart(key_values);
  }

  updateCart(key_values) {
    let updates = { updates: key_values };
    this._node.classList.add('--updating');

    fetch("/cart/update.js", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(updates),
    })
    .then((response) => {
      return response.json();
    })
    .then((cart) => {
      this.updateCartCount(cart.item_count);
      this.updateCartDrawer();
    })
  }

  updateCartCount(item_count) {
    let count = this._cart_btn.querySelector('.count');

    if (item_count > 0) {
      this._cart_btn.classList.remove('--empty');
    } else {
      this._cart_btn.classList.add('--empty');
    }

    count.innerText = item_count;
  }

  async updateCartDrawer() {
    const res = await fetch("/?section_id=cart-drawer");
    const text = await res.text();
    const html = document.createElement("div");
    html.innerHTML = text;
    const template = html.querySelector(".cart-drawer-box").innerHTML;

    document.querySelector(".cart-drawer-box").innerHTML = template;
    this._node.classList.remove('--updating');
  }

  /**
   * Handle unmount.
   */
   disconnectedCallback() {
     document.removeEventListener('keyup', this.onKeyup);
     this._cart_btn.removeEventListener('click', this.onClickCartBtn);
     this._node.removeEventListener('click', this.onClickDrawer);

     if (this._qty_minus.length > 0) {
       this._qty_minus.forEach((el) => {
         el.removeEventListener('click', this.onClickQtyDecrease);
       });
     }
     if (this._qty_plus.length > 0) {
       this._qty_plus.forEach((el) => {
         el.removeEventListener('click', this.onClickQtyIncrease);
       });
     }
     if (this._remove_btn.length > 0) {
       this._remove_btn.forEach((el) => {
         el.removeEventListener('click', this.onClickRemoveBtn);
       });
     }
  }
}
